export const industriesList = [
  'Accountancy',
  'Banking',
  'Collections',
  'Commercial Leasing',
  'Credit Cards',
  'Factoring',
  'Gambling',
  'Green Energy Finance',
  'Lettings Management',
  'Marketing',
  'Money Management',
  'Mortgages',
  'Motor Finance',
  'Other',
  'Retail Finance',
  'Salary Finance',
  'SME Lending',
  'Telecoms & Utilities',
  'Tenant Vetting',
  'Unsecured Lending',
].map((item) => ({ value: item, label: item }));

export const departmentsList = [
  'Accounting',
  'Business Development',
  'Credit Risk',
  'Customer Service',
  'Executive',
  'Finance',
  'Human Resources',
  'KYC',
  'Marketing',
  'Operations',
  'Other',
  'Sales',
  'Software Development',
].map((item) => ({ value: item, label: item }));

export const numberOfEmployeesOptionList = [
  { value: '1-10' },
  { value: '11-50' },
  { value: 'more than 50' },
].map(({ value }) => ({ value, label: value }));

export const numberOfCustomersOptionList = [
  { value: '0-1000' },
  { value: '1001-5000' },
  { value: '5001-50000' },
  { value: 'more than 50000' },
].map(({ value }) => ({ value, label: value }));

export const showTransactionDetailsOptionList = [
  { value: 'true', label: 'want to display' },
  { value: 'false', label: `don’t want to display` },
];
